import { render, staticRenderFns } from "./FloatingButtonsAdDetail.vue?vue&type=template&id=29aa818e&scoped=true"
import script from "./FloatingButtonsAdDetail.vue?vue&type=script&lang=js"
export * from "./FloatingButtonsAdDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa818e",
  null
  
)

export default component.exports